import { Button, Dialog, Portal, Text } from '@chakra-ui/react'

interface CancellationSentDialogProps {
  isOpen: boolean
  onClose: () => void
}

export function CancellationSentDialog({ isOpen, onClose }: CancellationSentDialogProps) {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={details => {
        if (!details.open) onClose()
      }}
      size="md"
      closeOnInteractOutside={false}
      closeOnEscape={false}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Stornorechnung wurde versandt</Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <Text>Die Stornorechnung wurde erfolgreich an den Rechnungsempfänger versandt.</Text>
            </Dialog.Body>

            <Dialog.Footer>
              <Button colorPalette="gray" onClick={onClose}>
                Fertig
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
